enum TenancyStep {
    LeaseAgreement = 0,
    Occupants = 1,
    Confirmation = 2
}

const tenancySteps = [
    { title: 'Lease agreement', description: 'Lease agreement details' },
    { title: 'Occupants', description: 'Occupants in this lease agreement' },
    { title: 'Confirmation', description: 'Confirm the thing' },
];

export {
    TenancyStep,
    tenancySteps,
};
